import React, { useEffect, useState, Fragment, useRef } from "react";
import { ReportTableContent } from '../../../Common/Table/tableContent';

export default class ComponentToPrint extends React.Component {
    render() {
        const data = this.props.data;
        const searchData = this.props.searchData;
        const contentRowNames = this.props.contentRowNames;
        const footerData = this.props.footerData;

        return (
            <div className="p-2">
                <h3><center><u>Daily Collection Summary Report</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.operationEntity}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.collectionPoint}</div>
                    <div className="col"><b>From Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                </div>
                <div className="table-responsive row-top-gap">
                    <table className="display dataTable no-footer">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th style={{ textAlign: "center" }}>Customer Count</th>
                                <th style={{ textAlign: "center" }}>Actual Amount (Kg)</th>
                                <th style={{ textAlign: "center" }}>Gross Amount (Kg)</th>
                                <th style={{ textAlign: "center" }}>Net Amount (Kg)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ReportTableContent
                                data={data}
                                contentRowNames={contentRowNames}
                                hasEdit={false}
                            />
                        </tbody>
                        <tfoot>
                            <tr>
                                <td><h6>Total</h6></td>
                                <td style={{ textAlign: "right" }}><h6>{footerData.customerCount}</h6></td>
                                <td style={{ textAlign: "right" }}><h6>{footerData.actualAmount}</h6></td>
                                <td style={{ textAlign: "right" }}><h6>{footerData.grossAmount}</h6></td>
                                <td style={{ textAlign: "right" }}><h6>{footerData.netAmount}</h6></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        );
    }
}


